export default {
    namespaced: true,
    chatbot: {
      input_placeholder: 'Pregunte aquí'
    }
  };  